<template>
    <div class="row">
      <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
        :destroy-on-close="true">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <setting-form @save="getSettings()" v-if="showForm" :setting="selected"></setting-form>
          </div>
        </div>
  
      </el-drawer>
  
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">Manage Settings</div>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            
            <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped" header-row-class-name="text-primary" :data="settings" style="width: 100%">
  
              <el-table-column :min-width="120"  class-name="td-actions" label="Name">
                <template slot-scope="props">
                  {{ props.row.name }}<br>
                </template>
              </el-table-column>

              <el-table-column :min-width="120"  class-name="td-actions" label="Type">
                <template slot-scope="props">
                  {{ props.row.type == 0 ? 'JSON':'String' }}<br>
                </template>
              </el-table-column>

              <el-table-column :min-width="120"  class-name="td-actions" label="Data">
                <template slot-scope="props">
                  {{ props.row.data }}<br>
                </template>
              </el-table-column>
    
              <el-table-column :min-width="120"  class-name="td-actions" label="Actions">
                <template slot-scope="props">

                  <el-button type="default" link @click="handleEdit(props.row)" size="mini">
                    <i class="fa fa-edit"></i>
                  </el-button>
                  <confirm-delete @onClick="handleDelete(props.row)" :label="'Delete'"></confirm-delete>
                </template>
              </el-table-column>
            </el-table>
          </div>
      
          
        </div>
      </div>
    </div>
  </template>
  <script>
  
  import { Setting } from '@/resources/setting'
import SettingForm from './SettingForm.vue'
import ConfirmDelete from '../../../Common/ConfirmDelete.vue'
  
  export default {
    components: { ConfirmDelete, SettingForm },
    data() {
        return {
        loading: false,
        showForm: false,
        settings: [],
        selected: null,
     
        term: null,
      }
    },
    watch: {
      term: function () {
        if (!this.term || this.term.length > 2) {
          this.getSettings()
        }
      },
    },
    created: function () {
      this.getSettings()
    },
    methods: {
      
      handleEdit(model) {
        this.showForm = true
        this.selected = Object.assign({}, model)
      },
      handleClose() {
        this.showDelete = false
        this.showForm = false
      },
      handleForm() {
        this.showForm = true
        this.selected = null
      },
      handleDelete(model) {
        this.loading = true
  
        Setting.delete(model.id)
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Setting has been removed',
            });
            this.getSettings()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
      },
      getSettings() {
        this.handleClose()
        let params = { term: this.term }
        this.loading = true
        Setting.get(params)
          .then(result => {
            if (result.data.settings)
              this.settings = result.data.settings
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch settings',
            });
  
          }).finally(() => {
            this.$loading = false
          })
      }
    }
  }
  </script>
  <style lang="scss"></style>
  